<template>
    <div class="viewBox">
       <div class="editor">
           <div class="left">
               <button @click="changePhoto(index)" :class="photoActiveIndex==index ? 'photoActive':''" v-for="(item,index) in photoList" :key="index">
                    <img  :src="`https://respool.isheji.com/isheji/static/qiye/image/lab/videoAutomaticLabel/${item}`" >
                    <span v-show="photoActiveIndex!=index " class="target" v-html="svg">
                    </span>
               </button>
            </div>
            <div class="center">
                <div class="buttonList">
                    <button @click="changeButton(index)" :class="buttonActiveIndex==index ? 'buttonActive':''" v-for="(item,index) in buttonList" :key="index" v-html="item.html+item.name"></button>
                </div>
                <div v-for="(item,index) in videoList" :key="index" style="width:100%">
                     <video  class="video" controls v-if="photoActiveIndex==index" v-on:timeupdate="changetime" :autoplay="false" :loop="false"  >
                        <source :src="item" type="video/mp4">
                    </video>
                </div>
                    
            </div>
            <div class="right" v-show="buttonActiveIndex==0">
                <div class="header">
                    <span>标签识别</span>
                    <span>置信度</span>
                </div>
                <div class="content" v-if="videoAuto[photoActiveIndex]">
                    <div class="item"  v-for="(item,index) in videoAuto[photoActiveIndex].automaticLabelByLoad[itemLabelCurrentIndex]" :key="index">
                     <p>{{item.title}}<span>{{item.score}}</span></p>
                    </div>
                </div>
            </div>
            <div class="right" v-show="buttonActiveIndex==1">
                <div class="header">
                    <span>人脸识别</span>
                    <span>置信度</span>
                </div>
                <div class="content" v-if="videoAuto[photoActiveIndex]">
                    <div v-show=" item.time == itemFaceCurrentIndex" 
                         v-for="(item,index) in videoAuto[photoActiveIndex].automaticFaceByLoad" :key="index">    
                        <div class="item" v-for="card in JSON.parse(item.lists)" :key="card.time">
                            <img :src="card.base64" alt="">
                            <p v-if="card.gender">性别<span>{{card.gender}}</span></p>
                            <p v-if="card.age">年龄<span>{{`${card.age[0]}-${card.age[1]}`}}</span></p>
                        </div>
                    </div>
                    <div v-show="itemFaceCurrentIndex == 10000">
                        <p class="noData">当前无面部数据</p>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
import Axios from "axios";

export default {
   
    data(){
        return{
            photoList:[
                '1.png',
                '2.png',
                '3.png',
                '4.png',
            ],
            videoList:[
                'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo1.mp4',
                 'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo2.mp4',
                  'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo3.mp4',
                   'https://respool.isheji.com/isheji/static/qiye/video/vcg/demo4.mp4',
            ],
            photoActiveIndex:0,
            videoAuto:[],
            svg:' <svg class="play_svg__icon" viewBox="0 0 1024 1024" width="200" height="200"><defs><style></style></defs><path d="M821.12 558.336l-494.08 275.2A47.808 47.808 0 01256 791.808V241.28a47.808 47.808 0 0171.04-41.792l494.08 275.264a47.808 47.808 0 010 83.52z" fill="#fff"></path></svg>',
            buttonList:[
                {
                    name:'标签识别',
                    html:'<svg width="18" height="18"><path d="M4.997 6.738V4.486h8.006v2.252H4.997zm0 3.992V8.478h8.006v2.252H4.997zm10.751 4.326V2.252H2.252v12.804l6.064-1.935a2.253 2.253 0 011.368 0l6.064 1.935zM17.57 0a.43.43 0 01.43.43v17.14a.43.43 0 01-.43.43L9 15.265.43 18a.43.43 0 01-.43-.43V.43A.43.43 0 01.43 0h17.14z" fill="#202437" fill-rule="evenodd"></path></svg>',
                },
                {
                    name:'人脸识别',
                    html:'<svg width="18" height="18"><path d="M9 5.715a1.375 1.375 0 000 2.748 1.375 1.375 0 000-2.748zm5.989 8.665h-2.483a3.174 3.174 0 00-3.171-3.17h-.67a3.174 3.174 0 00-3.17 3.17H3.012a5.655 5.655 0 013.044-5.01 3.701 3.701 0 01-.798-2.281A3.747 3.747 0 019 3.346a3.747 3.747 0 013.742 3.743 3.7 3.7 0 01-.797 2.281 5.655 5.655 0 013.044 5.01zM2.249 2.25v3.5H0V.337C0 .151.152 0 .339 0H5.75v2.25h-3.5zM17.664 0c.187 0 .337.151.337.337V5.75h-2.25v-3.5h-3.5V0h5.413zM15.75 15.75v-3.5H18v5.413c0 .186-.15.337-.337.337H12.25v-2.25h3.5zm-13.5-3.5v3.5h3.5V18H.338A.337.337 0 010 17.663V12.25h2.25z" fill="#202437" fill-rule="evenodd"></path></svg>'
                },
            ],
            buttonActiveIndex:0,
            itemLabelCurrentIndex:0,
            itemFaceCurrentIndex:10000
            
           
        }
    },

    methods:{
        changePhoto(index){
            this.photoActiveIndex = index;
        },
        changeButton(index){
            this.buttonActiveIndex = index;
        },
        changetime(item){
           this.itemLabelCurrentIndex = parseInt(item.target.currentTime);
           let hasTime = false;
           this.videoAuto[this.photoActiveIndex].automaticFaceByLoad.forEach((element,index) => {
               if(element.time == parseInt(item.target.currentTime)){
                    hasTime = true
                   this.itemFaceCurrentIndex = parseInt(item.target.currentTime)
               }
           });
           if(!hasTime){
               this.itemFaceCurrentIndex = 10000
           }
        }
    },
    created() {
       Axios.get('json/videoAutomaticLabel.json').then((res)=>{
            this.videoAuto = res.data;
       })
    },
}
</script>
<style lang="scss" scoped>
      .editor{
        width:100%;
        border-radius: 8px;
        overflow: hidden;
        background-color: #171a27;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: normal;
        justify-content: normal;
        -ms-flex-align: normal;
        align-items: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        margin-bottom: 16px;
        .left{
            width: 244px;
            position: relative;
            padding: 50px;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: start;
            justify-content: flex-start;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            button{
                width: 102px;
                height: 102px;
                border: none;
                padding: 0;
                overflow: hidden;
                position: relative;
                margin-top: 18px;
                &:first-child{
                    margin-top: 0;
                }
                cursor: pointer;
                img{
                    width: inherit;
                    height: inherit;
                    position: absolute;
                    top: 0;
                    left: 0;
                    -o-object-fit: cover;
                    object-fit: cover;
                    -o-object-position: center;
                    object-position: center;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
                .target{
                    opacity: 1;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    width: 32px;
                    height: 24px;
                    border-radius: 4px;
                    background-color: #fff;
                    pointer-events: none;
                    -webkit-transition: opacity ease-in-out 280ms;
                    -o-transition: opacity ease-in-out 280ms;
                    transition: opacity ease-in-out 280ms;
                    display: -ms-flexbox;
                    display: flex;
                    -ms-flex-pack: center;
                    justify-content: center;
                    -ms-flex-align: center;
                    align-items: center;
                    -ms-flex-direction: row;
                    flex-direction: row;
                    -ms-flex-wrap: nowrap;
                    flex-wrap: nowrap;
                }
            }
            .photoActive{
                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    z-index: 2;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    border: 4px solid transparent;
                    -webkit-transition: border-color ease-in-out 280ms;
                    -o-transition: border-color ease-in-out 280ms;
                    transition: border-color ease-in-out 280ms;
                    border-color: #5986ff;
                }
            }
        }
        .center{
                flex: 1 1;
            padding: 50px;
            background-color: #202537;
            position: relative;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: center;
            justify-content: center;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            img{
                position: relative;
                width: 100%;
                z-index: 1;
                min-height: 100px;
                overflow: hidden;
            }
            .rect{
                position: absolute;
                border: 4px solid #5986ff;
                z-index: 2;
            }
            .buttonList{
                margin-bottom: 24px;
                width: 100%;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: normal;
                justify-content: normal;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-direction: row;
                flex-direction: row;
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
                button{
                    cursor: pointer;
                    padding: 12px 26px;
                    margin-right: 8px;
                    border-radius: 4px;
                    background-color: #515666;
                    font-size: 14px;
                    line-height: 20px;
                    color: #202437;
                    font-weight: 400;
                    outline: none;
                    border: none;
                    &:last-child{
                        margin-right: 0;
                    }
                }
                .buttonActive{
                    color: #fff;
                    background-color: #5986ff;
                }
            }
        }
        .right{
            width: 244px;
            position: relative;
            .header{
                padding: 24px;
                color: #a0a3af;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                border-bottom: 1px solid rgba(81,86,102,0.5);
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: justify;
                justify-content: space-between;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-direction: row;
                flex-direction: row;
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }
            .content{
                position: relative;
                    z-index: 1;
                    padding: 0;
                    max-height: 484px;
                    min-height: 458px;
                    overflow-y: auto;
                    width: auto;
                     margin: 0;
                .item{
                   position: relative;
                    padding: 16px 24px;
                    border-bottom: 1px solid rgba(81,86,102,0.5);
                    -webkit-transition: background-color ease-in-out 280ms;
                    -o-transition: background-color ease-in-out 280ms;
                    transition: background-color ease-in-out 280ms;
                    img{
                        width: 60px;
                        height: 60px;
                        -o-object-position: center;
                        object-position: center;
                        -o-object-fit: cover;
                        object-fit: cover;
                        display: block;
                        margin-bottom: 16px;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                    }
                    p{
                        font-size: 14px;
                        line-height: 25px;
                        color: #fff;
                        margin: 0;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                        span{
                            float: right;
                        }
                    }
                    &:hover{
                        background-color: #202537;
                    }
                  
                }
                .noData{
                    padding: 24px;
                    margin: 0;
                    font-size: 16px;
                    line-height: 24px;
                    color: #a0a3af;
                }
            }
        }
    }
</style>
<style>
.target svg{
    width: 13px;
    height: 13px;
}
.target svg path{
    fill: #f84949;
}
.buttonList button svg{
    width: 20px;
    height: 20px;
    margin-right: 4px;
    vertical-align: middle;
}
.buttonList .buttonActive svg path{
    fill: #fff;
}
.play-pause-layer .btn-control{
    /* display: none; */
}
</style>